'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import { useChatStoreContext } from "../internals/useChatStoreContext/index.js";
export function useChatStore() {
  const store = useChatStoreContext(true);
  if (store == null) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Chat: useChatStore must be used within a <ChatProvider> component' : _formatErrorMessage(253));
  }
  return store;
}